import { onReady } from './util/onReady';

function moveAcceptButton() {
    const observer = new MutationObserver(() => {
        const onetrust = document.getElementById('onetrust-pc-sdk'); // Check for OneTrust element
        if (onetrust) {
            observer.disconnect(); // Stop observing once the element is found
            const acceptButton = document.getElementById('accept-recommended-btn-handler');
            const targetContainer = document.querySelector('.ot-btn-container');

            if (acceptButton && targetContainer) {
                acceptButton.parentElement?.removeChild(acceptButton);
                targetContainer.appendChild(acceptButton);
            } else {
                console.error('Accept button or target container not found.');
            }
        }
    });

    // Start observing with the configuration
    observer.observe(document.body, { childList: true, subtree: true });
}

function init(): void {
    if (window.location.hostname === 'localhost') return; //onetrust not added to localhost
    moveAcceptButton();
}

onReady(() => init());
